import { usePersonReadDataContext } from '@aibees/elephant/context';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { ContactDetailItemHeader } from '../../../contact-detail-item-header';
import { useContactDetailsState } from '../../context';
import { useSetSeemoreVisibility } from '../../hooks/use-set-seemore-visibility';
import * as EXTERNALSX from '../../sx';
import { LanguagesItem } from './components/languages-item';
import * as SX from './sx';
import type { LanguagesProps as Props } from './types';

export const Languages = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { api } = usePersonReadDataContext();
    const { isPopoverType } = useContactDetailsState();
    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      api.data?.languages?.profile_languages?.length
    );

    const content = (
      <Stack direction="column" gap={1}>
        {api.data?.languages?.profile_languages?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return <LanguagesItem key={index} item={item} index={index} />;
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Languages', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Languages"
          count={api.data?.languages?.profile_languages?.length ?? 0}
        />

        {isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Languages.displayName = 'Languages';
